<template>
    <div>
        <b-card
            tag="article"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="6" md="6" lg="6">
                        <b>Cliente:</b>
                        <div>{{satisfactionPoll.client.name}}</div>
                        <hr> 
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b>Sede:</b>
                        <div>{{satisfactionPoll.venue.name}}</div>
                        <hr>
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b>Estructura:</b>
                        <div>{{satisfactionPoll.structure.name}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b>Modalidad:</b>
                        <div> {{satisfactionPoll.satisfaction_poll_mode.name}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b>Encuestado:</b>
                        <div> {{satisfactionPoll.answered_by}}</div>
                        <hr> 
                    </b-col>
                    <b-col cols="6" md="6" lg="6">
                        <b>Reunión:</b>
                        <div> {{!!satisfactionPoll.contact_report ? satisfactionPoll.contact_report.id : '- Sin reunión -'}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b>Aspectos por mejorar:</b>
                        <div> {{!!satisfactionPoll.improovement_apects ? satisfactionPoll.improovement_apects : '- Sin comentarios -' }}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b>Aspectos positivos:</b>
                        <div> {{!!satisfactionPoll.positive_aspects ? satisfactionPoll.positive_aspects : '- Sin comentarios -'}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b>Mejora de la empresa:</b>
                        <div> {{!!satisfactionPoll.company_improovements ? satisfactionPoll.company_improovements : '- Sin comentarios -'}}</div> 
                        <hr>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b>Información de visita:</b>
                        <div> {{!!satisfactionPoll.call_information ? satisfactionPoll.call_information : '- Sin comentarios -'}}</div> 
                        <hr>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="12" lg="12">
                        <b-card
                            tag="article"
                            class="mb-2"
                            title="Cuestionario"

                        >
                        <div class="card-text">
                            <b-col v-for="(answer, i) in satisfactionPoll.satisfaction_poll_answers" :key="i" cols="12">
                                <b>{{i+1}}- {{ answer.satisfaction_poll_question.name }}:</b>
                                <div>Valoración: {{answer.value}}</div>
                                <div v-if="answer.notes">Notas: {{answer.notes}}</div>
                                <hr> 
                            </b-col>
                        </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        satisfactionPoll: {
            required: true
        }
    }
}
</script>
